import { Link } from "react-router-dom";
import { Split, Arrow } from "@/components/hm/Basics";
import { PublicVideo } from "@/components/hm/PublicVideo";

export const YouthVideo = () => (
  <section className="sec" id="video" data-testid="landing-youth-video">
    <div className="wrap">
      <div className="sec-head">
        <span className="eyebrow">Vídeo · menos de un minuto</span>
        <Split className="hm-h1" text="Mira este vídeo: en menos de un minuto" serif="entenderás si Heartmony es para ti." data-testid="landing-youth-video-title" />
        <p className="lead rv" data-testid="landing-youth-video-text">
          Un mensaje directo para jóvenes que sienten vacío, ruido, cansancio o desconexión.
          <br /><br />Este vídeo te ayuda a entender qué te está pasando y cómo Heartmony puede acompañarte a recuperar claridad, energía y dirección interna.
        </p>
      </div>
      <div style={{ maxWidth: 880 }}><PublicVideo slug="jovenes-video" testid="landing-youth-video" /></div>
      <div className="wm-cta rv" style={{ justifyContent: "flex-start" }}>
        <Link to="/modulo-bienvenida" className="btn btn-primary btn-hm wm-btn" data-testid="landing-youth-video-cta">Empezar ahora <Arrow /></Link>
      </div>
    </div>
  </section>
);
